<div class="box">
  <div class="header">
    <div class="title">
      <ppl-icon *ngIf="titleIcon"
                [svgIcon]="titleIcon"
                height="20px"
                width="20px"></ppl-icon>
      {{ title }}
    </div>
    <ng-content select="extra-header-content"></ng-content>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>